import trekronorTheme from "../../../trekronorTheme";
export default {
  ...trekronorTheme,
  // TODO: colors fix, färgerna krockar mellan border och font och bakgrund när man försöker overrida
  colors: {
    ...trekronorTheme.colors,
    link: trekronorTheme.colors.tertiary1,
    primary2: trekronorTheme.colors.primary5,
    primary1: trekronorTheme.colors.tertiary1
  },
  fontFamily: {
    ...trekronorTheme,
    serif: trekronorTheme.fonts.sans
  },
  fontWeight: {
    semibold: trekronorTheme.fontWeights.medium
  },
  borderRadius: {
    ...trekronorTheme.borderRadius,
    full: 0,
    default: 0
  }
};
